import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export async function lookupVin(vin, token) {
  const { data } = await axios.post(
    `${BACKEND_URL}/api/vehicles/vin-lookup`,
    { vin: String(vin || '').trim().toUpperCase() },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}

export function applyVinFields(form, fields) {
  if (!fields || typeof fields !== 'object') return form;
  const next = { ...form };
  Object.entries(fields).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return;
    if (key === 'features' && String(form.features || '').trim()) return;
    next[key] = value;
  });
  return next;
}

export function filledFieldNames(fields) {
  if (!fields) return [];
  return Object.entries(fields)
    .filter(([, value]) => value !== '' && value !== null && value !== undefined)
    .map(([key]) => key.replace(/_/g, ' '));
}
